export default "__VITE_ASSET__xJXDUxJZ__"